// extracted by mini-css-extract-plugin
export default {"container":"ParishBookCategoryEditModal_container__0XQ2W"};